/**
 * Zichtbaarheid van de CSV-importingang (CSV-5, P7).
 *
 * WAAROM DIT BESTAAT, en het is geen voorkeur maar een gemeten storing. De
 * CSV-wizard is met CSV-3 naar `main` gepusht en daarmee naar
 * `app.collectr.be`; de backend ging niet mee. Op productie stond dus een
 * zichtbare knop "Dossiers importeren" die de operator door drie stappen leidde
 * en dan faalde op `createBatch`, omdat de edge `import-commit` daar niet
 * bestond. Er ging niets half de database in — de batch is de eerste
 * schrijfactie — maar de belofte was vals.
 *
 * De regel die daaruit volgt en die deze module afdwingt: **een zichtbare CTA
 * met een backend die er niet is, is geen toegestane toestand.** Er zijn precies
 * twee: de import werkt end-to-end, of de ingang wordt niet aangeboden.
 *
 * SAFE-DEFAULT UIT. Alleen de exacte tekst `true` zet hem aan. Elke andere
 * waarde — leeg, ontbrekend, `1`, `yes`, een typefout — laat de ingang dicht.
 * Dat is bewust asymmetrisch: een vergeten variabele hoort een onzichtbare knop
 * op te leveren, niet een kapotte.
 *
 * Dezelfde vorm als `isIntakeBoundaryEnabled` (F0-C), zodat er één patroon voor
 * vlaggen in deze codebase blijft: pure module, geen `import.meta.env` hierin,
 * geen supabase-import — volledig unit-testbaar zonder omgeving.
 *
 * ROLLBACK EN UITROL zijn hetzelfde handvat: zet `VITE_CSV_IMPORT_ENABLED` op
 * `true` en bouw de frontend opnieuw. Geen codewijziging.
 */

/** Safe-default UIT: uitsluitend de exacte, getrimde tekst `true` opent de ingang. */
export function isCsvImportEnabled(rawEnv: string | undefined): boolean {
  return typeof rawEnv === "string" && rawEnv.trim().toLowerCase() === "true";
}
